require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-visualization-data-visualization-projects-visualize-data-with-a-scatterplot-graph.json") })
        }
      }, "path---data-visualization-data-visualization-projects-visualize-data-with-a-scatterplot-graph");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-visualization-data-visualization-projects-visualize-data-with-a-scatterplot-graph!./.cache/json/data-visualization-data-visualization-projects-visualize-data-with-a-scatterplot-graph.json
// module id = 1950
// module chunks = 231608221292675